import { useCallback, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import useCoordsAddress, { Coords } from '@amf/shared/hooks/useCoordsAddress';
import debounce from '@amf/shared/utils/debounce';
import TextField from '@amf/shared/components/form/TextField';
import Map from '@amf/shared/components/utils/Map';

interface TournamentFormMapProps {
  defaultCoords?: Coords | null;
  onChange: (coords: Coords | null) => void;
  error?: string;
}

export default function TournamentFormMap({
  defaultCoords,
  onChange,
  error,
}: TournamentFormMapProps) {
  const { t } = useTranslate('malyfotbal');
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [coords, setCoords] = useState<Coords | null>(defaultCoords ?? null);
  const { findCoordinates } = useCoordsAddress();

  const updateLocation = debounce(async () => {
    setLoading(true);
    const result = await findCoordinates(address);
    setLoading(false);
    setCoords(result);
    onChange(result);
  }, 1000);

  const update = useCallback(
    event => {
      setAddress(event.target.value);
      updateLocation();
    },
    [updateLocation],
  );

  return (
    <>
      <div className='TournamentForm__field'>
        <TextField
          label={t('tournaments.form.address')}
          type='text'
          value={address}
          onPaste={update}
          onChange={e => setAddress(e.target.value)}
          onBlur={update}
          error={loading ? undefined : error}
          loading={loading}
        />
        <p className='TournamentForm__helper'>{t('tournaments.form.address.helper')}</p>
      </div>
      <div className='TournamentForm__map'>
        {coords && (
          <Map
            title={address}
            lat={coords.lng}
            lng={coords.lat}
            zoom={12}
            width='100%'
            height='320px'
          />
        )}
      </div>
    </>
  );
}
